var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 138,
    viewBox: "0 0 441 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_9932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15C1 10.3406 1 8.01088 1.7612 6.17317C2.77614 3.72288 4.72288 1.77614 7.17317 0.761205C9.01088 0 11.3406 0 16 0H426C430.659 0 432.989 0 434.827 0.761205C437.277 1.77614 439.224 3.72288 440.239 6.17317C441 8.01088 441 10.3406 441 15V123C441 127.659 441 129.989 440.239 131.827C439.224 134.277 437.277 136.224 434.827 137.239C432.989 138 430.659 138 426 138H16C11.3406 138 9.01088 138 7.17317 137.239C4.72288 136.224 2.77614 134.277 1.7612 131.827C1 129.989 1 127.659 1 123V15Z",
    fill: "url(#paint0_linear_283_9932)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412,
    cy: 114,
    r: 40,
    fill: "#7D53EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 20,
    r: 72,
    fill: "#7D53EB",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 102.5,
    r: 71.5,
    fill: "#7D53EB",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_9932",
    x1: 514.503,
    y1: 11.9752,
    x2: -2.50338,
    y2: 98.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7041DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970134,
    stopColor: "#253280"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_9932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 138,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5fc15ec8c5ac1eef9812bfcd3d065bd7.svg";
export { ForwardRef as ReactComponent };